export default __webpack_public_path__ + "static/media/camp.9949b4ae.png";